// config.js
const config = {
    // backendUrl: 'http://192.10.250.112:5001', 
         backendUrl: "https://loyaltyapi.dilipsindia.com", 
      // backendUrl: "https://dilipsindiaapi.stellifyflows.in",
        //  backendUrl: "http://localhost:5001",

  };
  
  export default config;
  